// extracted by mini-css-extract-plugin
var _1 = "entry";
var _2 = "heading";
var _3 = "logo";
var _4 = "mobileDevice";
export { _1 as "entry", _2 as "heading", _3 as "logo", _4 as "mobileDevice" }
